import type { QueryClient, QueryKey } from '@tanstack/react-query';

import type { GetThesesRow } from '../generated/openapi-types.gen.js';
import type { PagedData } from '../types/PagedData.js';

const THESES_LIST_PREFIX = ['theses', 'list'] as const;

export function prependOptimisticThesis(
  queryClient: QueryClient,
  marketPubkey: string,
  row: GetThesesRow,
): void {
  queryClient.setQueriesData<PagedData<GetThesesRow>>(
    {
      predicate: ({ queryKey }: { queryKey: QueryKey }): boolean =>
        isMatchingRecentMarketFeed(queryKey, marketPubkey),
    },
    (previous) => {
      if (previous === undefined) return previous;
      if (previous.data.some((candidate) => candidate.signature === row.signature)) return previous;
      return { ...previous, data: [row, ...previous.data] };
    },
  );
}

export function hasThesisInCache(queryClient: QueryClient, signature: string): boolean {
  return queryClient
    .getQueriesData<PagedData<GetThesesRow>>({ queryKey: THESES_LIST_PREFIX })
    .some(([, page]) => page?.data.some((row) => row.signature === signature) === true);
}

function isMatchingRecentMarketFeed(queryKey: QueryKey, marketPubkey: string): boolean {
  if (queryKey[0] !== THESES_LIST_PREFIX[0] || queryKey[1] !== THESES_LIST_PREFIX[1]) return false;
  const args = queryKey[2];
  if (args === null || typeof args !== 'object') return false;
  const feed = args as { readonly marketPubkey?: unknown; readonly sort?: unknown };
  return feed.marketPubkey === marketPubkey && feed.sort === 'recent';
}
